export default "__VITE_ASSET__D$v1eSrX__"